import React from 'react'

import { Skeleton, TableSkeleton } from '@/components/ui'

const InitialAlertAcknowledgementSkeleton: React.FC = () => (
  <div className="space-y-2">
    <div className="w-full rounded-md bg-white pt-2 pb-2 pl-4 pr-4 shadow-sm">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
        <div className="w-full sm:w-auto space-y-2">
          <div className="flex flex-row gap-2 items-center">
            <div className="w-48">
              <Skeleton height="32px" />
            </div>
            <div className="w-20">
              <Skeleton height="24px" />
            </div>
          </div>
          <div className="flex flex-wrap gap-3">
            <div className="w-48">
              <Skeleton height="20px" />
            </div>
            <div className="w-48">
              <Skeleton height="20px" />
            </div>
          </div>
        </div>
        <div className="flex items-center w-full sm:w-auto">
          <div className="w-32">
            <Skeleton height="36px" />
          </div>
        </div>
      </div>
    </div>

    <div className="grid grid-cols-1 lg:grid-cols-5 lg:grid-rows-[minmax(0,1fr)_minmax(0,1fr)] gap-4 h-[850px]">
      <div className="lg:col-span-3 rounded-md bg-white pt-2 pb-2 pl-4 pr-4 shadow-sm space-y-2 flex flex-col min-h-0">
        <div className="w-56">
          <Skeleton height="20px" />
        </div>
        <div className="flex-1 min-h-0">
          <Skeleton height="100%" />
        </div>
      </div>
      <div className="lg:row-span-2 lg:col-span-2 lg:col-start-4 lg:row-start-1 rounded-md bg-white p-2 shadow-sm min-h-0">
        <Skeleton height="100%" />
      </div>
      <div className="lg:col-span-3 rounded-md bg-white pt-2 pb-2 pl-4 pr-4 shadow-sm space-y-2 flex flex-col min-h-0">
        <div className="w-40">
          <Skeleton height="20px" />
        </div>
        <div className="flex-1 min-h-0 overflow-hidden">
          <TableSkeleton rows={5} columns={4} withHeader rowHeight={35} />
        </div>
      </div>
    </div>
  </div>
)

export default InitialAlertAcknowledgementSkeleton
